module.exports = __webpack_public_path__ + "static/media/melbourne-logo.5454a27f.svg";